import React from "react";
import styles from "./styles.module.scss";

const Dropzone = ({ onDrop, onFileClick }) => {
  return (
    <div
      className={styles.dropzone}
      onDrop={onDrop}
      onDragOver={(e) => e.preventDefault()}
      onClick={onFileClick}
    >
      Click to upload or drag & drop file here
    </div>
  );
};

export default Dropzone;
